
function fn_set_product_action(addToQuantity = false,itemsList = false, quickBtn = false, object_number = false, parentProduct){
  /*
   * セット子商品のデータ取得
   */
  if(!itemsList){
   var itemsList = document.querySelector('#addItemList').value;
  } else {
   itemsList = JSON.stringify(itemsList);
  }
  if(itemsList != "null" && itemsList.length > 0){
    var itemsListArray = JSON.parse(itemsList);
    var productCheckResponse = productChecker(itemsListArray);
    fn_productCheckResponse(productCheckResponse);
    if(!quickBtn){
     setTimeout(() => {
       var redirectToCheckoutBtn = document.querySelector('.shopify-payment-button');
       redirectToCheckoutBtn.remove();
     },1000)
    }
  }
  
  /*
  * 商品在庫確認
  */
  function productChecker(itemsListArray){          
    var promise = new Promise(async (resolve, reject) => {
      var check_available = true;
      for(i=0;i<Object.keys(itemsListArray).length;i++){
        var handle = itemsListArray[i].product_handle;
        var product_info = await getProductInfo(handle);
        if(!product_info.available){
          resolve(false);
          break;
        }
      }
      resolve(true);
    });
    return promise;
  }
 
  /*
  * セット商品の在庫確認
  */
  function fn_productCheckResponse(productCheckResponse){
    productCheckResponse.then(
      (res) => {
        if(!quickBtn){
         var addToCartProducts = document.querySelector('#products-add-cart');
         var addToCartProductsText = document.querySelector('#products-add-cart .atc-button--text');
        } else {
         var addToCartProducts = document.querySelector('#products-add-cart-quick_'+ object_number);
         var addToCartProductsText = document.querySelector('#products-add-cart-quick_'+ object_number +' .atc-button--text');
        }
        if(res){
          fnaddToCartProducts(addToCartProducts);
        } else {
          addToCartProducts.disabled = true;
          addToCartProducts.classList.add('disabled');
          addToCartProductsText.innerText = "Sold out";
          
        }
      }
    );
  }
  
  /*
  * 子商品をカートに追加
  */
  function fnaddToCartProducts(addToCartProducts){
    addToCartProducts.addEventListener('click',() => {
      var addProducts = {items:[]};
      if(!addToQuantity){
        var quantitySelector = document.querySelector('#product-quantity-select');
        if(quantitySelector.tabIndex != "-1" ){
          addToQuantity = document.querySelector('#product-quantity-select').value;
        } else {
          addToQuantity = document.querySelector('#product-quantity-input').value;
        }
      }
      for(i=0;i<Object.keys(itemsListArray).length;i++){
        var variant = itemsListArray[i].id;
        var addProduct = {
          'id': variant,
          'quantity': addToQuantity,
          properties: {
            'SetProduct': parentProduct
          }
        }
        addProducts.items.push(addProduct);
      }
      addToCartProducts.classList.add('processing');
      addProducts.items = addProducts.items.reverse();
      updateCartProduct(addProducts);
    });
  }
  
  /*
  * カートへ追加処理
  */
  function updateCartProduct(formData){
    fetch('/cart/add.js',{
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    },{
    }).then((res) => {
      // 商品が正常に追加されない場合の処理
      if(res.ok){
        location.href = '/cart'
      } else {
        alert('申し訳ありません。カートに商品が追加できませんでした。')
        location.reload();
      }
    }).catch((error) => {
      console.log(error);
    });
  }
  
  /*
  * 商品データ取得
  */
  function getProductInfo(handle){
    return new Promise(resolve => {
      fetch('/products/'+ handle +'.js'
      ).then(response => response.json())
      .then(data => {
        resolve(data);
      }).catch((error) => {
        console.log(error);
      });
    });
  }
 }